// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Error-handler {
  text-align: center;
  margin-top: 50px;
}
.Error-handler .Error-handler-button {
  margin-top: 15px;
  color: var(--color_primary_500);
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Error/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,+BAAA;EACA,iBAAA;AACJ","sourcesContent":[".Error-handler {\n  text-align: center;\n  margin-top: 50px;\n\n  .Error-handler-button {\n    margin-top: 15px;\n    color: var(--color_primary_500);\n    font-weight: bold;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
